import { render, staticRenderFns } from "./ExpertList.vue?vue&type=template&id=52084e63&"
import script from "./ExpertList.vue?vue&type=script&lang=js&"
export * from "./ExpertList.vue?vue&type=script&lang=js&"
import style0 from "./ExpertList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports